"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2817],{

/***/ 47018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CoverageInfoCard; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/international-insurance/components/landing-page/styles.module.scss
var styles_module = __webpack_require__(22934);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/common/utils/config/index.ts
var config = __webpack_require__(79354);
;// CONCATENATED MODULE: ./src/international-insurance/components/landing-page/common/CoveragePills.tsx



var Index = function(param) {
    var list = param.list;
    var ref = (0,compat_module.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    (0,compat_module.useEffect)(function() {
        var interval = setInterval(function() {
            var ref;
            if (currentIndex < ((ref = list[0]) === null || ref === void 0 ? void 0 : ref.length)) setCurrentIndex(function(prevIndex) {
                var ref;
                return (prevIndex + 1) % ((ref = list[0]) === null || ref === void 0 ? void 0 : ref.length);
            });
            else setCurrentIndex(0);
        }, 600);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
        children: list === null || list === void 0 ? void 0 : list.map(function(value, index) {
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "".concat((styles_module_default()).coveragePill, " ").concat(currentIndex === index ? (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).activeCoveragePill : ""),
                children: value
            }, index);
        })
    });
};
/* harmony default export */ var CoveragePills = (Index);

;// CONCATENATED MODULE: ./src/international-insurance/components/landing-page/common/CoverageInfoCard.tsx






var CoverageInfoCard_Index = function(param) {
    var carousalItem = param.carousalItem;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: (styles_module_default()).coverageInfoCardContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: (styles_module_default()).coverageInfoCardImage,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.image_url,
                    height: "250px",
                    width: "320px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: (styles_module_default()).coverageInfoCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: (styles_module_default()).coverageInfoCardTitle,
                        children: carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: (styles_module_default()).coverages,
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CoveragePills, {
                            list: carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.values
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: (styles_module_default()).coverageInfoNote,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: config/* ASSETS.BLACK_INFO_ICON */.ou.BLACK_INFO_ICON,
                                height: "20px",
                                width: "20px",
                                style: {
                                    minWidth: "20px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: (styles_module_default()).coverageInfoNoteText,
                                children: carousalItem === null || carousalItem === void 0 ? void 0 : carousalItem.note_text
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CoverageInfoCard = (CoverageInfoCard_Index);


/***/ }),

/***/ 62817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22934);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40706);
/* harmony import */ var _common_CoverageInfoCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47018);





var Index = function() {
    var ref;
    var cover_info_section = _config__WEBPACK_IMPORTED_MODULE_2__/* .LANDING_PAGE_DATA.cover_info_section */ .BF.cover_info_section;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().coverageInfoSection),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().coverageInfoContent),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().coverageInfoHead),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sectionTitle),
                            style: {
                                margin: "unset"
                            },
                            children: cover_info_section.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().coverageInfoHighlight),
                            children: cover_info_section.colored_text
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().coverageInfoSubtitle),
                            children: cover_info_section.subtitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().coverageInfoCards),
                    children: cover_info_section === null || cover_info_section === void 0 ? void 0 : (ref = cover_info_section.cover_list) === null || ref === void 0 ? void 0 : ref.map(function(info) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_common_CoverageInfoCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            carousalItem: info
                        }, info.title);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

}]);